import React from "react"
import { ColorSwatch as SwatchType } from "@/app/(site)/contexts/Global/types"
import SwatchImage from "./SwatchImage"

interface ColorSwatchProps {
    swatch: SwatchType
    selectedColor: string
    onSwatchSelect: (uri: string) => void
    handleChangeVariant: () => void
}

const ColorSwatch: React.FC<ColorSwatchProps> = ({
    swatch,
    selectedColor,
    onSwatchSelect,
    handleChangeVariant
}) => {
    const { uri, color_name } = swatch

    const handleSwatchClick = () => {
        if (uri) {
            onSwatchSelect(uri)
            handleChangeVariant()
        }
    }

    return (
        <div
            onClick={handleSwatchClick}
            role="button"
            aria-label={`Select color: ${color_name}`}
            className={`relative ${
                color_name === selectedColor
                    ? "rounded-full border border-black p-2"
                    : "p-[3px]"
            }`}
            aria-pressed={color_name === selectedColor}
        >
            <span className="block cursor-pointer rounded-full border border-main-medium-grey">
                <SwatchImage swatch={swatch} />
            </span>
        </div>
    )
}

export default ColorSwatch
